'use client';

import { useEffect, useState } from 'react';

import { useModel } from '@/hooks/useModel';

const Intercom = () => {
  const [isClient, setIsClient] = useState<boolean>(false);
  const { userProfile } = useModel('auth-model', (model) => ({
    userProfile: model.userProfile
  }));

  useEffect(() => {
    setIsClient(true);

    const win = window as any;

    if (typeof win.Featurebase !== 'function') {
      win.Featurebase = function () {
        // eslint-disable-next-line prefer-rest-params
        (win.Featurebase.q = win.Featurebase.q || []).push(arguments);
      };
    }

    if (userProfile) {
      win.Featurebase('identify', {
        organization: 'mebot',

        email: userProfile.email,
        name: userProfile.name,
        id: userProfile.userId,

        customFields: {
          ENV: process.env.NEXT_PUBLIC_APP_ENV,
          APP: 'Web'
        }
      });

      win.Featurebase('initialize_portal_widget', {
        organization: 'mebot', // required
        placement: 'right',
        fullScreen: false, // optional
        initialPage: 'MainView', // optional (MainView, RoadmapView, CreatePost, PostsView, ChangelogView)
        metadata: null // Attach session-specific metadata to feedback. Refer to the advanced section for the details: https://developers.featurebase.app/install/advanced#metadata
      });
    }
  }, [userProfile]);

  return isClient ? (
    <button data-featurebase-feedback-portal style={{ display: 'none' }}>
      Open Widget
    </button>
  ) : null;
};

export default Intercom;
